import React, { ForwardedRef, forwardRef, InputHTMLAttributes } from "react";
import styled from "styled-components";
import { InputLabel } from "../Typography";
import { Input } from "./Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const SearchBar = styled(Input)<{
  $whiteSearchBar?: boolean;
}>`
  display: inline;
  font-size: 16px;
  padding-left: 2rem;

  &:focus {
    box-shadow: none;
  }

  ${({ $whiteSearchBar, theme }) =>
    $whiteSearchBar &&
    `
    background-color: white;
    border-color: ${theme.input.border.color};

  &:focus {
    background-color: white;
    border-color: ${theme.input.focus.border.color};
  }
  `}
`;

const IconWrapper = styled.span`
  position: absolute;
  left: 8px;
  top: 6px;
  display: inline;
  z-index: 2;
  color: ${({ theme }) => theme.colors.primary};
`;

const SearchParent = styled.div`
  position: relative;
`;

interface SearchBarWithLabelProps
  extends InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  label?: string;
  whiteSearchBar?: boolean;
  handleChange?: (text: string) => void;
}

export const SearchBarWithLabel = forwardRef(
  (
    {
      id,
      label,
      whiteSearchBar,
      handleChange,
      ...props
    }: SearchBarWithLabelProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <>
        {label && <InputLabel htmlFor={id}>{label}</InputLabel>}
        <SearchParent>
          <SearchBar
            ref={ref}
            type={"search"}
            $whiteSearchBar={whiteSearchBar}
            id={id}
            onChange={({ target }) =>
              handleChange && handleChange(target.value)
            }
            {...props}
          />
          <IconWrapper>
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </IconWrapper>
        </SearchParent>
      </>
    );
  }
);
